import ReactApexChart from "react-apexcharts";
import { DoughnutWrapper } from "./style";

export interface IDonutChart {
  title?: string;
  colors?: string[];
  categories: string[];
  series: any;
  height?: string | number;
}

export function DoughnutChart({
  height,
  series,
  categories,
  colors,
  title,
}: IDonutChart) {
  const total = series.reduce((acc: any, val: any) => (acc += val), 0);

  const options: any = {
    labels: categories,
    colors,
    chart: {
      type: "donut",
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            // width: 300,
            width: "100%", // Making it flexible for small screens
          },
          legend: {
            // position: "bottom",
            position: "right",
          },
        },
      },
    ],
    legend: {
      show: true,
      showForSingleSeries: false,
      showForNullSeries: true,
      showForZeroSeries: true,
      position: "left",
      horizontalAlign: "center",
      floating: false,
      fontSize: "16px",
      fontFamily: "Helvetica, Arial",
      fontWeight: 400,
      formatter: (seriesName: any, opts: any): any => {
        return [
          seriesName,
          "  - ",
          Math.ceil((opts.w.globals.series[opts.seriesIndex] / total) * 100) +
            "%",
        ];
      },
      inverseOrder: false,
      width: 150,
      height: undefined,
      tooltipHoverFormatter: undefined,
      customLegendItems: [],
      offsetX: 0,
      offsetY: 10,
      labels: {
        colors: undefined,
        useSeriesColors: false,
      },
      markers: {
        size: 6,
        shape: undefined, // circle, square, line, plus, cross
        strokeWidth: 2,
        fillColors: undefined,
        customHTML: undefined,
        onClick: undefined,
        offsetX: 0,
        offsetY: 0,
      },
      itemMargin: {
        horizontal: 5,
        vertical: 5,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
    plotOptions: {
      pie: {
        offsetX: -3,
        offsetY: 0,
        donut: {
          size: "42%",

          labels: {
            show: true,
            value: {
              show: true,
              fontSize: "16px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              color: undefined,
              offsetY: -30,
              formatter: function (val: any) {
                const total = series?.reduce(
                  (sum: any, currVal: any) => (sum += parseInt(currVal)),
                  0
                );
                const isBlur = val === total;
                const percent = ((parseFloat(val) / total) * 100)?.toFixed(1);
                const percentDisp = val + `(${percent}%)`;
                const valueToReturn = isBlur ? total : percentDisp;
                return valueToReturn;
              },
            },
            name: {
              show: true,
              fontSize: "14px",
              fontWeight: 600,
              color: undefined,
              offsetY: 10,
              formatter: function (val: any) {
                return val;
              },
            },
            total: {
              show: true,
              showAlways: false,
              fontSize: "14px",
              label: "Total",
              fontWeight: 400,
              color: undefined,
              // offsetY: 16,
            },
          },
        },
      },
    },
  };
  if (typeof window === "undefined") return null;
  return (
    <DoughnutWrapper>
      <h2 className="chart-title">{title}</h2>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
          height={height || 330}
        />
      </div>
      <div id="html-dist"></div>
    </DoughnutWrapper>
  );
}
